window.addEventListener('load', (event) => {
  var inputs = document.querySelectorAll('input.js__radiocheck');
  inputs.forEach(input => input.addEventListener('change', function() {
    var this_check = this.checked;
    inputs.forEach(input => input.checked = false);
    if (this_check) {
        this.checked = true;
    } else {
        this.checked = false;
    }
  }));
});